import sdl from '@jds/react-generated-sdl/JDSAvatarV2';
import type { JDSAvatarV2Props } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSAvatarV2Props) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'default',
    size = 'medium',
    disabled = false,
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { kind, size, disabled, ...rest },
    'JDSAvatarV2',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const AvatarV2 = withLogic(Component) as React.FC<JDSAvatarV2Props> & {
  slotName?: string;
};

AvatarV2.displayName = 'AvatarV2';
AvatarV2.slotName = 'jds_avatar';

export { AvatarV2, type JDSAvatarV2Props };
